/**
 * The kinds a field definition can have.
 *
 * Lives here rather than on FieldInput so that non-UI modules — TimeEditAPI among them — can
 * branch on a field's kind without importing a component, which would put a cycle between the
 * API layer and the component tree.
 */
export const FieldKind = {
    UNKOWN: 0,
    INTEGER: 1,
    TEXT: 2,
    EMAIL: 3,
    URL: 4,
    TELEPHONE: 5,
    COMMENT: 6,
    BOOLEAN: 7,
    SIGNATURE: 8,
    CATEGORY: 9,
    REFERENCE: 10,
    LENGTH: 11,
    TEXT_NO_SEARCH: 12,
    REFERENCE_NO_SEARCH: 13,
} as const;

export type FieldKindType = (typeof FieldKind)[keyof typeof FieldKind];
